module.exports = __webpack_public_path__ + "media/images/fax-66ffa02a57c80d574fa153695cdf8c11.png";